import searchReducer from "./searchReducer";

export * from "./searchReducer";

export default searchReducer;
